<template>
  <div class="home-wrapper">
    <!-- 用户信息 -->
    <div class="card-wrapper user-info">
      <img :src="userInfo.avatar" alt="" class="avatar" />
      <div class="inner">
        <p class="name">{{ userInfo.nickName }}</p>
        <p>迷你号：{{ userInfo.uin }}</p>
        <div class="num-list">
          <div class="num-item">
            作品：<strong class="num">{{ developerInfo.product || 0 }}</strong>
          </div>
          <div class="line"></div>
          <div class="num-item">
            关注：<strong class="num">{{ developerInfo.follow || 0 }}</strong>
          </div>
          <div class="line"></div>
          <div class="num-item">
            粉丝：<strong class="num">{{ developerInfo.fans || 0 }}</strong>
            <!-- 暂时不做 -->
            <!-- <span class="up-box"><i class="up-icon"></i> 20</span> -->
          </div>
        </div>
        <!-- 开发者等级 -->
        <!-- <div v-if="isDeveloper" class="dev-btn">
          开发者LV {{ developerInfo.level }}
        </div> -->
        <!-- 成为开发者 -->
        <!-- <div v-else class="dev-btn apply" @click="handleRegiste">
          成为开发者<i class="icon"> </i>
        </div> -->
      </div>
    </div>
    <!--公告-->
    <div class="announcement-wrap">
      <div class="content-wrap" v-if="annoceCount">
        <van-swipe :autoplay="4000" lazy-render>
          <van-swipe-item v-for="item in annoceData" :key="item">
            <a :href="item.jumpUrl" class="item" target="_blank">
              <div class="content">
                <div class="type">【{{ item.type }}】</div>
                <div class="title">{{ item.title }}</div>
              </div>
              <div class="time">{{ item.createTime }}</div>
            </a>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="no-content" v-else>暂无公告</div>
    </div>
    <div class="slideshow-wrap">
      <!-- 轮播图 -->
      <van-swipe :autoplay="3000" class="my-swiper" @change="bannerShow">
        <van-swipe-item v-for="(item, index) in banners" :key="index">
          <a :href="item.jump_url" target="_blank" class="img-inner">
            <img
              :src="item.image_url"
              :alt="`图片${item.id}`"
              @click="bannerClick(item.id)"
          /></a>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 内容区 -->
    <div class="home-content">
      <div class="income-wrap">
        <div class="income-title">
          <div class="name">概览</div>
          <div class="desc">过去三十日累计数据</div>
          <i class="ques-icon inc-area" @click.stop="handleShowRule"></i>
        </div>
        <!-- <div class="devide-line"></div> -->
        <!-- 收益 -->
        <div class="card-wrapper income" @click="navToPage('/income/data')">
          <span class="income-name">收益</span>
          <div class="card-list">
            <div
              v-for="(item, index) of incomeData"
              :key="index"
              class="card-item"
            >
              <p class="type">{{ item.title }}</p>
              <p class="num">{{ item.value | regroupWan }}</p>
              <p class="prev-day">昨日 {{ item.yes | regroupWan }}</p>
            </div>
          </div>
          <i class="right-arrow"></i>
        </div>
      </div>
      <!-- 地图 -->
      <div class="card-wrapper map" @click="navToPage('/charts/map')">
        <span class="map-name"> 地图 </span>
        <div class="card-list">
          <div v-for="(item, index) of mapData" :key="index" class="card-item">
            <p class="type">{{ item.title }}</p>
            <p class="num">{{ item.value | regroupWan }}</p>
            <p class="prev-day">昨日 {{ item.yes | regroupWan }}</p>
          </div>
        </div>
        <i class="right-arrow"></i>
      </div>
      <!--学院课程展示-->
      <div id="college">
        <div class="title-wrapper">
          <div class="title">
            <span class="title-content">学院</span>

            <span class="more">
              <a href="https://dev-wiki.mini1.cn/" target="_blank">
                <span><i class="right-arrow"></i> </span>
              </a>
            </span>
          </div>
          <div class="desc">{{ contentTitle }}</div>
        </div>
        <div class="college-content" v-if="collegeClass.length">
          <div
            class="img-content"
            v-for="(item, index) in collegeClass"
            :key="index"
          >
            <a :href="item.url" target="_blank" @click="postCollege(item.id)">
              <van-image
                class="image-cover"
                :src="item.cover"
                alt="照片加载出错"
              >
              </van-image>
              <div class="class-intro">
                <span class="intro">{{ item.title }}</span>
                <!-- <span class="count">{{ item.visitorsCount || 0 }}</span> -->
              </div>
            </a>
          </div>
        </div>
        <div class="list-no" v-else>
          <!-- <img class="img" src="../assets/images/img_table_no_data.png" /> -->
          <div class="desc">暂无推荐课程</div>
        </div>
      </div>
      <!-- TODO - 资源 -->
      <!-- <div class="card-wrapper resource">
      <span class="name">资源</span>      
      <i class="right-arrow"></i>
    </div> -->
      <!-- 非开发者遮罩 -->
      <masking v-if="isInfoLoaded && !isDeveloper" :homeType="true"></masking>
    </div>
    <!-- 规则说明 -->
    <van-popup
      v-model="isRuleVisible"
      closeable
      position="bottom"
      :style="{ height: '50%' }"
    >
      <help-rule>
        <pre slot="regular">
广告收益：玩家观看作品内的广告后产生的收益；
贡献点：玩家使用迷你币消费您的作品或道具；
迷你点：玩家使用迷你点购买了作品或资源
迷你豆：玩家使用迷你豆购买了作品或资源；
下载次数：地图作品被玩家下载的累计次数
浏览次数：地图作品详情页（工坊或大厅内）被玩家查看的累计次数
游玩次数：地图作品被玩家进入游玩累计次数
游玩时长：地图作品被玩家进入停留游玩的累计时长
        </pre>
      </help-rule>
    </van-popup>
  </div>
</template>

<script>
import HelpRule from '@/components/HelpRule';
import Masking from '@/components/Masking';
import { getKfzInfo, getHomeOverview, getHomeBanners } from '@/api/common';
import { getStudioDetail } from '@/api/studio';
import { getBankInfo } from '@/api/income';
import { createRegisterUrl, _regroupWan } from '@/utils';
import { mapState, mapMutations } from 'vuex';
import { repeatCertify, getAnnoce, getCollege } from '@/api/common';
// 默认的首页数据
const normalOverviewData = {
  map_download_count: 500,
  old_map_download_count: 100,
  map_comment_count: 500,
  old_map_comment_count: 100,
  ad_income: 500,
  old_ad_income: 100,
  contribution: 500,
  old_contribution: 100,
  minipoint: 500,
  old_minipoint: 100,
  minibean: 500,
  old_minibean: 100,
};

export default {
  components: {
    HelpRule,
    Masking,
  },
  mounted() {},
  created() {
    if (this.userInfo.loginFormUrl) {
      this.twoNewCertify();
    } else {
      this.twoCertify();
    }
    this.init();
    this.Report('view', 'HomePage');
  },
  data() {
    return {
      isInfoLoaded: false,
      isRuleVisible: false,
      registerUrl: createRegisterUrl(),
      annoceData: [], //公告数组
      annoceCount: 0,
      collegeClass: [], //课程列表
      // 地图数据
      mapData: [],

      // 收益数据
      incomeData: [],

      banners: [],
      studioBaseInfo: null,
    };
  },
  computed: {
    ...mapState(['userInfo', 'developerInfo']),
    isDeveloper() {
      return [1, 2].includes(this.developerInfo.state);
    },
  },
  filters: {
    regroupWan(num, toFixed) {
      return _regroupWan(num, toFixed);
    },
  },
  methods: {
    ...mapMutations([
      'SET_BANK_INFO',
      'SET_DEVELOPER_INFO',
      'ADD_ASYNC_ROUTES',
    ]),
    init() {
      this.getStudioBaseInfo();
      this.getAnnoceData();
      this.fetchKfzInfo();
      this.fetchBankInfo();
      this.fetchBanners();
      this.miinShow();
      //获取学院信息
      this.getCollegeClass();
    },
    async twoCertify() {
      let data = {
        uin: this.userInfo.uin,
      };
      let res = await repeatCertify(data);
      let token2 = sessionStorage.getItem('token2');
      console.log(token2);
      if (res.code === 500 && !token2) {
        //   debugger;
        this.$router.push({
          name: 'Certify',
          params: { uin: this.userInfo.uin },
        });
      }
    },
    //获取学院课程
    async getCollegeClass() {
      const res = await getCollege({});
      if (res.data) {
        this.contentTitle = decodeURIComponent(res.data.title);
        this.collegeClass = res.data.articleList;
      }
    },
    //获取公告数据
    async getAnnoceData() {
      let data = { size: 15 };
      let now_date = new Date(new Date() - 14 * 24 * 60 * 60 * 1000).getTime();
      const res = await getAnnoce(data);
      this.annoceData = res.data.map(item => {
        if (item.createTime * 1000 > now_date) {
          item.tagIdsNew = 'NEW';
        } else {
          item.tagIdsNew = '';
        }
        item.createTime = this.timeConvert(item.createTime);
        item.type = item.type === 1 ? '活动' : '通知';
        item.tagIds = item.tagIds === '1' ? 'HOT' : '';
        item.title = decodeURIComponent(item.title);
        // item.title =
        //   '创作者中心创作者中心创作者中心创作者中心创作者中心创作者创作者中心创作者中心创作者创做';
        item.jumpUrl = decodeURIComponent(item.jumpUrl);
        return item;
      });
      this.annoceCount = res.data.length || 0;
      console.log(this.annoceData);
    },
    //将时间戳转化为年-月-日
    timeConvert(time) {
      let date = new Date(time * 1000);
      let year =
        date.getFullYear() < 10 ? '0' + date.getFullYear() : date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      // let result = year + '-' + month + '-' + day;
      let result = month + '-' + day;
      return result;
    },
    async twoNewCertify() {
      let data = {
        uin: this.userInfo.uin,
      };
      let res = await repeatCertify(data);
      let token2 = sessionStorage.getItem('token2');
      //   console.log('++++'+token2)
      //  debugger
      //   console.log('---'+res.code)
      if (res.code === 500 && !token2) {
        //  debugger;
        this.$router.push({
          name: 'Certify',
          params: { uin: this.userInfo.uin },
        });
      }
    },
    async getStudioBaseInfo() {
      const res = await getStudioDetail({ json: 1 });
      this.studioBaseInfo = res.data;
      if (this.studioBaseInfo) {
        sessionStorage.setItem(
          'studioBaseInfo',
          JSON.stringify(this.studioBaseInfo),
        );
      }
    },
    // 获取首页 banner
    async fetchBanners() {
      const { data } = await getHomeBanners();
      this.banners = data.list;
    },
    //轮播图点击埋点
    bannerClick(id) {
      this.$log('banner_click', 85403, { v7: 2, v8: id });
    },
    //主页展示埋点
    miinShow() {
      this.$log('miin_show', 85401, { v7: 2 });
      if (this.developerInfo.state == 0 || this.developerInfo.state == 3)
        this.beDeveloperShow();
    },
    //轮播图展示埋点
    bannerShow(key1) {
      let id1 = this.banners[key1].id;
      this.$log('banner_show', 85402, { v7: 2, v8: id1 });
    },
    //成为开发者按钮展示
    beDeveloperShow() {
      this.$log('become_developer_show', 85404, { v7: 2 });
    },
    //成为开发者点击埋点
    // becomeDeveloper() {
    //   console.log('123456789');
    //   this.$log('become_developer_click', 85405, { v7: 2 });
    // },
    // 获取首页数据
    async fetchHomeOverview() {
      const { data } = await getHomeOverview();
      this.setOverviewData(data);
    },
    // 获取开发者信息
    async fetchKfzInfo() {
      // 优化请求次数 - beforeEach 中已请求一次
      let info = JSON.parse(sessionStorage.getItem('developerInfo') || '{}');
      if (!Object.keys(info).length) {
        const res = await getKfzInfo();
        info = res.data;
      }

      this.isInfoLoaded = true;

      const { state } = info;

      // 0，3 表示非开发者
      if ([0, 3].includes(state)) {
        this.setOverviewData(normalOverviewData);
      } else {
        this.fetchHomeOverview();
      }
    },
    // 获取银行卡信息
    async fetchBankInfo() {
      const { data } = await getBankInfo();
      this.SET_BANK_INFO(data);
    },
    // 设置首页数据
    setOverviewData(data) {
      // 地图数据
      this.mapData = [
        {
          title: '下载次数',
          value: data.map_download_count,
          yes: data.old_map_download_count,
        },
        // {
        //   title: '评论数',
        //   value: data.map_comment_count,
        //   yes: data.old_map_comment_count,
        // },
        {
          title: '浏览次数',
          value: data.map_browse_count,
          yes: data.old_map_browse_count,
        },
        {
          title: '游玩次数',
          value: data.map_play_count,
          yes: data.old_map_play_count,
        },
        {
          title: '游玩时长(分)',
          value: Number(data.map_play_time / 60).toFixed(1),
          yes: data.old_map_play_time / 60,
          toFixed: 1,
        },
      ];
      // 收益数据
      this.incomeData = [
        {
          title: '广告收益',
          value: data.ad_income,
          yes: data.old_ad_income,
        },
        {
          title: '贡献点',
          value: data.contribution,
          yes: data.old_contribution,
        },
        { title: '迷你点', value: data.minipoint, yes: data.old_minipoint },
        { title: '迷你豆', value: data.minibean, yes: data.old_minibean },
      ];
    },
    // 路由跳转
    navToPage(path) {
      if (!this.isDeveloper) return;

      this.$router.push(path);
    },
    // 跳转到开发者注册页
    handleRegiste() {
      //  this.becomeDeveloper();
      //  setTimeout(() => this.clickHref(), 300);
      this.sendBeacon(
        'https://tj2.mini1.cn/miniworld?v1=90001&v2=undefined&v3=undefined&v4=undefined&v5=undefined&v6=H5&v7=2&k=85405',
      );
      window._hmt &&
        window._hmt.push([
          '_trackEvent',
          'become_developer_click',
          85405,
          this.$track.getCommonStatParams(),
          'v1=90001&v2=undefined&v3=undefined&v4=undefined&v5=undefined&v6=H5&v7=2&k=85405',
        ]);
      this.clickHref();
    },
    sendBeacon(url) {
      if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
        return navigator.sendBeacon(url);
      }
      try {
        let req = new window.XMLHttpRequest();
        req.open('GET', url, false);
        req.send();
      } catch (e) {
        // Fix IE9 cross-site error
        let img = new window.Image();
        img.src = url;
      }
    },
    clickHref() {
      window.location.href = this.registerUrl;
    },
    // 显示规则
    handleShowRule() {
      // this.isRuleVisible = true;
      this.$router.push({ name: 'Hiptip' });
    },
  },
};
</script>

<style lang="less" scoped>
.home-content {
  position: relative;
  min-height: 549px;
}

.user-info {
  position: relative;
  display: flex;
  align-items: center;

  min-height: 120px;

  .avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
  }

  .inner {
    flex: 1;
    padding-left: 26px;

    .name {
      padding: 6px 0 13px;
      font-size: 28px;
      line-height: 24px;
    }
  }

  .num-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;

    .num-item {
      display: flex;
    }

    .num {
      font-weight: bold;
    }

    .line {
      width: 1px;
      height: 20px;
      background: #d9d9d9;
    }

    .up-box {
      display: flex;
      justify-content: center;
      align-items: center;

      height: 32px;
      margin-left: 10px;
      padding: 0 10px;
      background-color: #fffaed;
      border: 1px solid #ffc973;
      font-size: 22px;
      color: #fd9b21;
      border-radius: 15px;

      .up-icon {
        width: 14px;
        height: 14px;
        margin-right: 4px;
        background: url(~@/assets/images/up-arrow.png) no-repeat;
        background-size: contain;
      }
    }
  }

  .dev-btn {
    position: absolute;
    top: 20px;
    right: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    padding: 0 28px;
    background-color: #fd9b21ff;
    border-radius: 40px;
    font-size: 24px;
    color: #fff;
    // text-align: center;
    &.apply {
      background-color: #fd9b21;
    }
    .icon {
      width: 26px;
      height: 26px;
      margin-left: 4px;
      background: url(~@/assets/images/white-arrow.png) no-repeat;
      background-size: contain;
    }
  }
}
.income-wrap {
  // background-color: #fff;
  //padding: 20px 32px;
  margin-bottom: 20px;
  //padding: 20px 32px 0px 32px;
  .income-title {
    display: flex;
    padding: 24px 0px 15px 0;
    align-items: center;
    width: 710px;
    .name {
      font-size: 32px;
      font-weight: 600;
      color: #262626;
      margin-right: 10px;
      white-space: nowrap;
      flex: 0 0 auto;
    }
    .desc {
      font-size: 24px;
      color: #8c8c8c;
      margin-right: 390px;
    }
  }
  .devide-line {
    width: 662px;
    height: 1px;
    background: #d8d8d8;
    margin-left: 24px;
  }
}
.card-wrapper {
  position: relative;
  min-height: 160px;
  margin-bottom: 10px;
  padding: 20px 32px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;

  &.map {
    min-height: 260px;
    .map-name {
      font-size: 34px;
      color: #000000;
      line-height: 48px;
      font-weight: 500;
    }
  }
  &.income {
    min-height: 260px;
    padding: 24px 0;
    .income-name {
      font-size: 32px;
      font-weight: 400;
      color: #000000;
      margin-left: 24px;
    }
    .right-arrow {
      position: absolute;
      top: 20px;
      right: 31px;
      height: 27px;
      margin-top: 5px;
      width: 29px;
    }
  }

  .name {
    position: relative;
    font-size: 34px;
    width: 360px;
    color: #000000;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ques-icon {
    position: absolute;
    top: 50%;
    right: -45px;
    transform: translateY(-50%);
  }

  .card-list {
    display: flex;
    justify-content: space-between;
    //padding-top: 12px;
  }

  .card-item {
    flex: 1;
    margin-right: 26px;
    padding: 20px 10px;
    background: red;
    border-radius: 8px;
    text-align: center;

    .type {
      font-size: 26px;
    }

    .num {
      padding: 6px 0;
      font-size: 34px;
      color: #fd9b21;
    }

    .prev-day {
      font-size: 24px;
      color: #8c8c8c;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &.map {
    padding: 24px 0;
    .map-name {
      font-size: 32px;
      color: #000000;
      margin-left: 24px;
    }
    .card-list {
      flex-wrap: wrap;
    }
    // .card-item {
    //   flex-shrink: 0;
    //   min-width: 40%;
    //   margin-bottom: 26px;
    // }
    .card-item {
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
    .right-arrow {
      position: absolute;
      top: 20px;
      right: 32px;
      width: 29px;
      height: 27px;
      margin-top: 10px;
    }
  }

  &.income,
  &.map {
    .card-item {
      position: relative;
      margin-right: 0;
      background-color: #fff;
      .type {
        font-size: 26px;
        color: #000000;
        line-height: 40px;
      }
      .num {
        font-size: 36px;
        font-weight: 500;
      }
      .prev-day {
        font-size: 24px;
        color: #8c8c8c;
      }
      &::after {
        content: '';

        position: absolute;
        top: 0;
        right: 0;
        width: 1px;
        height: 100%;
        background: #d9d9d9;
        border-top: 30px solid #fff;
        border-bottom: 30px solid #fff;

        box-sizing: border-box;
        opacity: 0.7;
      }

      &:last-child::after {
        display: none;
      }
    }
  }
}
.announcement-wrap {
  .content-wrap {
    .van-swipe-item {
      .item {
        background: #ffffff;
        //  width: 710px;
        display: flex;
        align-items: center;
        height: 74px;
        margin-top: 15px;
        margin-bottom: 20px;
        font-size: 28px;
        color: #000000;
        border-radius: 8px;
        .content {
          width: 566px;
          display: flex;
          margin-right: 40px;
        }
        .time {
          color: #8c8c8c;
        }
      }
      .van-swipe__indicators {
        display: none;
      }
    }
    /deep/.van-swipe__indicators {
      display: none;
    }
  }
  .no-content {
    height: 74px;
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    background: #ffffff;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    font-size: 28px;
    color: #000000;
  }
}

.my-swiper {
  height: 152px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
  .img-inner {
    display: block;
    width: 100%;
    height: 152px;

    > img {
      width: 730px;
      height: 152px;
    }
  }
}
#college {
  min-height: 360px;
  height: 100%;
  background-color: #fff;
  margin-top: 24px;
  padding: 24px;
  border-radius: 8px;
  color: #595959;
  margin-bottom: 40px;
  .title-wrapper {
    .title {
      padding-bottom: 8px;
      display: flex;
      font-size: 34px;
      color: #000000;
      .title-content {
        font-size: 32px;
        font-weight: 400;
      }
      .more {
        float: right;
        margin-right: 10px;
        vertical-align: middle;
        margin-top: 10px;
        a {
          color: #595959;
          text-decoration: none;
        }
      }
    }
    .desc {
      font-size: 28px;
      color: #8c8c8c;
      padding-bottom: 6px;
    }
  }
  .college-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow: scroll;
    .img-content {
      margin-right: 15px;
      margin-bottom: 20px;
      width: 221px;
      flex-shrink: 0;
      cursor: pointer;
      a {
        color: #262626;
        text-decoration: none;
      }
      .image-cover {
        width: 221px;
        height: 154px;
        background-size: contain;
      }
      .class-intro {
        font-size: 18px;
        padding-top: 10px;
        .intro {
          max-width: 208px;
          display: inline-block;
          white-space: nowrap; /*超出的空白区域不换行*/
          overflow: hidden; /*超出隐藏*/
          text-overflow: ellipsis; /*文本超出显示省略号*/
        }
        .count {
          float: right;
          margin-right: 5px;
          color: #595959;
        }
      }
    }
  }
  .list-no {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .desc {
      margin-top: 8px;
      font-size: 18px;
    }
    .intro-content {
      margin-top: 60px;
    }
  }
  .right-arrow {
    position: absolute;
    // background: url(~@/assets/images/icon_arrow.png) no-repeat;
    right: 31px;
    display: block;
    height: 27px;
    //margin-top: 5px;
    width: 29px;
  }
}
</style>
